"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var d3 = require("d3");

var Scaffold = /*#__PURE__*/function (_Component) {
  _inherits(Scaffold, _Component);

  var _super = _createSuper(Scaffold);

  function Scaffold() {
    _classCallCheck(this, Scaffold);

    return _super.apply(this, arguments);
  }

  _createClass(Scaffold, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      document.getElementById("alignmentjs-scaffold-div").addEventListener("alignmentjs_wheel_event", function (e) {
        d3.select("#alignmentjs-guide-rect").attr("x", e.detail.x_fraction * _this.props.width).attr("y", e.detail.y_fraction * _this.props.height);
      });
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          scroll_broadcaster = _this$props.scroll_broadcaster,
          sender = _this$props.sender,
          guide_svg = d3.select("#alignmentjs-scaffold");
      guide_svg.on("click", function () {
        var coords = d3.mouse(this),
            x_fraction = coords[0] / width,
            y_fraction = coords[1] / height;
        scroll_broadcaster.broadcast(x_fraction, y_fraction, sender);
      });
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(e) {
      e.preventDefault();
      this.props.scroll_broadcaster.handleWheel(e, this.props.sender);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.sequence_data) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          id: "alignmentjs-scaffold-div"
        });
      }

      var _this$props2 = this.props,
          sequence_data = _this$props2.sequence_data,
          scroll_broadcaster = _this$props2.scroll_broadcaster,
          width = _this$props2.width,
          height = _this$props2.height,
          sender = _this$props2.sender,
          _scroll_broadcaster$s = scroll_broadcaster[sender],
          x_pad = _scroll_broadcaster$s.x_pad,
          y_pad = _scroll_broadcaster$s.y_pad,
          alignment_width = _scroll_broadcaster$s.width,
          alignment_height = _scroll_broadcaster$s.height,
          number_of_sites = sequence_data[0].seq.length,
          number_of_sequences = sequence_data.length,
          guide_width = this.props.width * x_pad / alignment_width,
          guide_height = this.props.height * y_pad / alignment_height,
          line_style = {
        stroke: "red",
        strokeWidth: "1px"
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "alignmentjs-scaffold-div",
        onWheel: function onWheel(e) {
          return _this2.handleWheel(e);
        }
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        width: width,
        height: height,
        id: "alignmentjs-scaffold"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: 0,
        y: 0,
        width: width,
        height: height,
        fill: "WhiteSmoke"
      }), sequence_data.map(function (row, index) {
        var y = height * index / number_of_sequences;
        var start = false,
            end = false;

        for (var i = 0; !start || !end; i++) {
          if (!start && row.seq[i] != "-") {
            start = i;
          }

          if (!end && row.seq[row.seq.length - i - 1] != "-") {
            end = row.seq.length - i - 1;
          }
        }

        return /*#__PURE__*/_react["default"].createElement("line", {
          x1: width * start / number_of_sites,
          x2: width * end / number_of_sites,
          y1: y,
          y2: y,
          key: index,
          style: line_style
        });
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "alignmentjs-guide-rect",
        x: 0,
        y: 0,
        width: guide_width,
        height: guide_height,
        fill: "darkgrey",
        fillOpacity: 0.8,
        stroke: "white",
        strokeWidth: 1
      })));
    }
  }]);

  return Scaffold;
}(_react.Component);

Scaffold.defaultProps = {
  sender: "main"
};
var _default = Scaffold;
exports["default"] = _default;